import React, { useRef, useState }  from 'react';
import { Modal, Form, Button }      from 'react-bootstrap';
import { useDispatch }              from 'react-redux';
import { Formik }                   from 'formik';
import * as yup                     from 'yup';

import { ErrorMessage }             from '../../../../extras/toastMessages';
import { ICON_SAVE, ICON_CANCEL }   from '../../../../extras/icons';
import { MSG_ERROR_SERVER }         from '../../../../../constants/messages';
import { updateSalaAction }         from '../../../../../actions/audiencesActions';

import ButtonSpinner                from '../../../../layout/ButtonSpinner'
import clienteAxios                 from '../../../../../config/axios';




const SalaForm = props => {



    // ---------------------------------------------------------------------------------------------------------------------
    // DECLARACIONES -------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------------------
    
    // Tomo los props
    const { show, handleClose, audience } = props;

    // Genero los ref
    const refSala = useRef();

    // Inicializo datos
    const initialData = {
        sala: audience && audience.sala ? audience.sala.id : ''
    }

    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Inicializo el state local
    const [loading, setLoading] = useState(false);
    const [salas, setSalas] = useState([]);



    // ---------------------------------------------------------------------------------------------------------------------
    // FUNCIONES -----------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------------------

    // Manejo cuando se muestra
    const handleOnShow = e => {
        // Cargo los motivos
        loadParameters();
        // Pongo el foco en el primer campo
        refSala.current.focus();
    }

    // Manejo el guardado
    const handleSave = async values => {
        // Armo los datos
        const data = {
            salaId: values.sala
        }
        // Llamo al dispatch
        dispatch( updateSalaAction(audience, data, handleClose) );
    }

    // Función que cargar los parámetros
    const loadParameters = async () => {
        try
        {   // Sala
            const responseSalas = await clienteAxios.get(`/sala?search=activo:1&sort=descripcion:asc`);
            setSalas(responseSalas.data.content);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            // Verifico si hay error
            if(response)
            {   data = response.data;
            }
            // Mensaje de error
            ErrorMessage(data.message);
        }
    }

    // Esquema de validación
    const validationSchema = yup.object({
        sala: yup.number().required()
    });



    // ---------------------------------------------------------------------------------------------------------------------
    // RENDERIZO -----------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------------------
    
    return (
        <Modal
            show = { show } 
            onHide = { handleClose } 
            onShow = { handleOnShow } 
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Editar Sala <small>(Audiencia #{ audience && audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema = { validationSchema }
                initialValues = {{ ...initialData }}
                onSubmit = { values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Seleccione la Sala que desea asignar.
                                    </div>
                                </div>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        as = "select"
                                        id = "sala"
                                        className = "form-control"  
                                        name = "sala"  
                                        value = { values.sala }
                                        onChange = { handleChange }
                                        ref = { refSala }
                                        isInvalid = { !!errors.sala }
                                        disabled = { loading }
                                    >
                                        <option value="">Seleccione Sala...</option>
                                        {   salas.map(o => (
                                                <option value={ o.id } key={`oefo${o.id}`}>
                                                    { o.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.sala }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {   loading 
                                    ?
                                        <ButtonSpinner />
                                    :
                                        <Button variant="success" type="submit" disabled={ loading }>
                                            <ICON_SAVE /> <strong>ACTUALIZAR</strong>
                                        </Button>
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default SalaForm;